import React from 'react';
import { ActionButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

function porInstructions(){
  return (
  <div>
    <div className='instruction-content'>
      <p>The period of record allows you to visualize the percentage difference between two alternatives over time.</p>
    </div>
    
    <div className='instruction-section'>
      <h3>Creating a Period of Record Chart</h3>
      <div className='instruction-content'>
        <p>By default, the locations available are filtered to only display "Favorite" locations which are pre defined or added manually by you.</p>
        <div className='flex align-center'>Use the <ActionButton iconProps={{iconName: 'FavoriteStarFill'}}>Filter Favorites</ActionButton> button to show all locations, or switch back to the favorite list.</div>
        <p>Use the dropdown menu's select a location, type, base alternative and an alternative to compare.</p>
        <div className='flex align-center'>Click  <PrimaryButton style={{margin: '0px 5px'}}>Apply</PrimaryButton> to load the data.</div>
      </div>
    </div>

    <div className='instruction-section'>
      <h3>Example Period of Record Chart</h3>
      <div className='instruction-content'>
        <img src='../../../images/por_example.png' alt='Period of Record Example' width="100%"/>
        <p>
          When the data loads, you will see a heat map chart which reads 
          from left to right, top to bottom by day. Years range from 1931 - 2012 
          on the y-axis. Days range from January 1 - Dec 31 on the x-axis. 
          The colors on the chart indicate the percentage difference between 
          the base and compared alternative. When you see blue, the compared 
          alternative value is larger than the base alternative. When you see red, 
          the compared alternative value is lower than the base alternative. 
          Areas that appear white indicate both alternatives perform the same
        </p>
      </div>
    </div>

    <div className='instruction-section'>
      <h3>Underlying Data</h3>
      <div className='instruction-content'>
        <div className='flex-align-top'>
          <img src='../../../images/por_hover_tip.png' alt='Period of Record Hover Tip' width="300px"/>
          <div style={{marginLeft: '10px'}}>
            <p>
            When you hover over the heat map with your cursor, a tool-tip will display data corresponding to the day and year you are hovered over.
            </p>
            <p>Clicking on the heat map will populate a table with the data. And enable the <PrimaryButton style={{magin: '0px 5px'}}>Open Chart</PrimaryButton> button.</p>
          </div>
        </div>
        <div className='flex-align-top'>
          <img src='../../../images/por_table.png' alt='Period of Record Table' width="300px"/>
          <p style={{marginLeft: '10px'}}>
            Clicking the Open Chart button will redirect you the the Charts page and automatically 
            open this location and seclected alternatives and in a line chart.
          </p>
        </div>
      </div>
    </div>

  </div>
  )
}

export default porInstructions


// WEBPACK FOOTER //
// ./src/components/instructions/porInstructions.js